import { render, staticRenderFns } from "./UnitArrivalInstructions.vue?vue&type=template&id=27874a9c&scoped=true"
import script from "./UnitArrivalInstructions.vue?vue&type=script&lang=js"
export * from "./UnitArrivalInstructions.vue?vue&type=script&lang=js"
import style0 from "./UnitArrivalInstructions.vue?vue&type=style&index=0&id=27874a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27874a9c",
  null
  
)

export default component.exports